// libraries
import { Typography } from '@interstate/components/Typography';

// constants
import * as constants from '../../constants';
import type { CompareColumnDetailProps } from '../types/compareColumnDetailProps';

// components
import AddsToCapCost from '../../dealSummary/sections/AddsToCapCost.interstate';
import AdjCapCost from '../../dealSummary/sections/AdjCapCost.interstate';
import CashDown from '../../dealSummary/sections/CashDown.interstate';
import DealerDiscounts from '../../dealSummary/sections/DealerDiscounts.interstate';
import Discount from '../../dealSummary/sections/Discount.interstate';
import GrossCapCost from '../../dealSummary/sections/GrossCapCost.interstate';
import MonthlyPayment from '../../dealSummary/sections/MonthlyPayment.interstate';
import MSRP from '../../dealSummary/sections/MSRP.interstate';
import NetTrade from '../../dealSummary/sections/NetTrade.interstate';
import Rebates from '../../dealSummary/sections/Rebates.interstate';
import SellingPrice from '../../dealSummary/sections/SellingPrice.interstate';
import TermLength from '../../dealSummary/sections/TermLength.interstate';
import TotalDueAtSigning from '../../dealSummary/sections/TotalDueAtSigning.interstate';
import TotalOfPayments from '../../dealSummary/sections/TotalOfPayments.interstate';
import TotalResidual from '../../dealSummary/sections/TotalResidual.interstate';
import { ColumnDetailsBlock, OfferCompareCardBlock, StyledListBordered } from './CompareColumnDetail.style';

export const CompareLeaseColumnDetail = ({ deal, deltaList }: CompareColumnDetailProps) => {
    return (
        <ColumnDetailsBlock data-testid="compare-lease-column-detail">
            <OfferCompareCardBlock rowName="pricing">
                <Typography variant="h4">{constants.PRICE}</Typography>
                <StyledListBordered>
                    <MSRP deal={deal} />
                    <Discount deal={deal} hasDelta={deltaList.isDiscountDelta} />
                    <DealerDiscounts deal={deal} hasDelta={deltaList.isDiscountDelta} />
                    <SellingPrice deal={deal} hasDelta={deltaList.isSellingPriceDelta} />
                </StyledListBordered>
            </OfferCompareCardBlock>

            <OfferCompareCardBlock rowName="addons">
                <Typography variant="h4">{constants.ADDS_TO_CAP_COST}</Typography>
                <StyledListBordered>
                    <AddsToCapCost deal={deal} hasDelta={deltaList.isAdjustedCapCostDelta} />
                    <GrossCapCost deal={deal} hasDelta={deltaList.isNetSellingPriceDelta} />
                </StyledListBordered>
            </OfferCompareCardBlock>

            <OfferCompareCardBlock rowName="finance-reductions">
                <Typography variant="h4">{constants.CAP_COST_REDUCTION}</Typography>
                <StyledListBordered>
                    <NetTrade deal={deal} hasDelta={deltaList.isNetTradeDelta} />
                    <Rebates deal={deal} hasDelta={deltaList.isRebatesDelta} />
                    <CashDown deal={deal} hasDelta={deltaList.isCashDownDelta} />
                    <AdjCapCost deal={deal} />
                </StyledListBordered>
            </OfferCompareCardBlock>

            <OfferCompareCardBlock rowName="financing-terms">
                <Typography variant="h4">{constants.LEASING_TERMS}</Typography>
                <StyledListBordered>
                    <TotalResidual deal={deal} hasDelta={deltaList.isTotalResidualDelta} />
                    <TermLength deal={deal} hasDelta={deltaList.isTermDelta} />
                    <MonthlyPayment deal={deal} hasDelta={deltaList.isMonthlyPaymentDelta} />
                    <TotalDueAtSigning deal={deal} hasDelta={deltaList.isTotalDueDelta} />
                    <TotalOfPayments deal={deal} hasDelta={deltaList.isTotalOfPaymentsDelta} />
                </StyledListBordered>
            </OfferCompareCardBlock>
        </ColumnDetailsBlock>
    );
};
